import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import API from "../../API/API";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const ContainerBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  height: 100%;
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 2vw;
  background-color: #ffffff;
  box-shadow: 0 0.5vh 0.5vh rgba(0, 0, 0, 0.03),
    0 0.5vh 0.5vh rgba(0, 0, 0, 0.003);
  border-radius: 1vw;
  width: 100%;
  height: 7vw;
  /* outline: 1px solid red; */
  &:hover {
    cursor: pointer;
    outline: 0.3vw solid #fff6f1;
  }
`;

const ListText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 2vw;
`;
export default function IntroductionImageList() {
  const [imageViewPageVisible, setImageViewPageVisible] = useState<any>(false);
  const [id, setId] = useState<any>();
  const [imageList, setImageList] = useState<any[]>([]);
  const navigate = useNavigate();
  const IntroductionImageViewPageShow = (item: any) => {
    navigate(`/introduction-image`, { state: { item: item } });
  };
  // 가입된 유저리스트 받아오기
  const getImageList = async () => {
    try {
      const response = await API.get("/company/profile");
      setImageList(response.data.getResult);
    } catch (error) {
      alert(error);
    }
  };
  useEffect(() => {
    getImageList();
  }, []);

  return (
    <>
      <Container>
        <ContainerBox>
          {imageList.map((item) => (
            <ListContainer
              key={item.id}
              onClick={() => IntroductionImageViewPageShow(item)}
            >
              <ListText>{item.name}</ListText>
            </ListContainer>
          ))}
        </ContainerBox>
      </Container>
    </>
  );
}
